
<ng-container *ngIf="isLoaded">
  <div class="card mb-3">
    <div class="card-body">
      <div class="pt-4 pb-2">
        <h5 class="card-title text-center pb-0 fs-4">Отваряне на Каса</h5>
        <p class="text-center small">Моля, въведете данните</p>
      </div>

      <form [formGroup]="Form" class="row g-3 needs-validation" (ngSubmit)="onSubmit()">
        <div class="col-12">
          <label for="startAmount" class="form-label">Начално Салдо</label>
          <input type="text" formControlName="startAmount" class="form-control" id="startAmount">
        </div>
        <div class="col-12">
          <label for="createdOn" class="form-label">Начална Дата</label>
          <input type="text" formControlName="createdOn" class="form-control" id="createdOn">
        </div> 
        <div class="col-12">
          <button class="btn btn-primary w-100" type="submit" [disabled]="!Form.valid">Отвори</button>
        </div>
      </form>
    </div>
  </div>

</ng-container> 
